/**
 * @fileoverview Status de uma conexão para exibição: rótulo (traduzido) e cor.
 * Usado na tela de Conexões e no modal Iniciar conversa.
 */

import { i18n } from "../translate/i18n";

// No modo claro o texto do status usa o tom 700 da mesma cor — o 500 (verde,
// âmbar, azul) não tem contraste sobre fundo claro. A bolinha segue na cor viva.
export const STATUS_TEXT_ON_LIGHT = {
  '#22c55e': '#15803d',
  '#ef4444': '#b91c1c',
  '#f59e0b': '#b45309',
  '#3b82f6': '#1d4ed8',
  '#0ea5e9': '#0369a1',
  '#7c3aed': '#6d28d9',
  '#94a3b8': '#475569',
  '#cbd5e1': '#475569',
};

// Status (já em maiúsculas) → chave da tradução e cor. Os da WAHA (STOPPED,
// STARTING, SCAN_QR_CODE, WORKING, FAILED, PASSKEY_*) e os do canal antigo não
// se repetem, então cabem num mapa só.
const STATUS = {
  CONNECTED: { label: "connections.status.connected", color: '#22c55e' },
  WORKING: { label: "connections.status.connected", color: '#22c55e' },
  DISCONNECTED: { label: "connections.status.disconnected", color: '#ef4444' },
  OPENING: { label: "connections.status.opening", color: '#f59e0b' },
  STARTING: { label: "connections.status.starting", color: '#f59e0b' },
  QRCODE: { label: "connections.status.qrcode", color: '#3b82f6' },
  SCAN_QR_CODE: { label: "connections.status.scanQr", color: '#3b82f6' },
  TIMEOUT: { label: "connections.status.timeout", color: '#ef4444' },
  FAILED: { label: "connections.status.failed", color: '#ef4444' },
  STOPPED: { label: "connections.status.stopped", color: '#94a3b8' },
  PAIRING: { label: "connections.status.pairing", color: '#0ea5e9' },
  PENDING: { label: "connections.status.pending", color: '#0ea5e9' },
  PASSKEY_REQUIRED: { label: "connections.passkey.pill", color: '#7c3aed' },
  PASSKEY_CONFIRMATION_REQUIRED: { label: "connections.passkey.pillConfirm", color: '#7c3aed' },
};

export const getConnectionStatus = (status, provider, livechatEnabled) => {
  // LiveChat: sem sessão externa — Ativo/Inativo espelha o toggle do widget
  if (provider === "livechat") {
    return livechatEnabled !== false
      ? { label: i18n.t("connections.livechat.active"), color: '#22c55e' }
      : { label: i18n.t("connections.livechat.inactive"), color: '#94a3b8' };
  }

  const info = STATUS[(status || "").toUpperCase()];
  return info ? { label: i18n.t(info.label), color: info.color } : { label: status, color: '#cbd5e1' };
};
